class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    this.content = this.mainDetailsToggle.querySelector('summary')?.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content) return;
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.openTimer = null;
    this.closeTimer = null;
    this.desktopQuery = window.matchMedia('(min-width: 990px)');
    this.summaryElement = this.mainDetailsToggle?.querySelector('summary');

    this.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.addEventListener('mouseleave', this.closeOnHover.bind(this));
    this.addEventListener('pointerenter', this.openOnHover.bind(this));
    this.addEventListener('pointerleave', this.closeOnHover.bind(this));
    this.addEventListener('focusin', this.openOnHover.bind(this));
    this.summaryElement?.addEventListener('click', this.preventDesktopClickToggle.bind(this), true);
  }

  preventDesktopClickToggle(event) {
    if (!this.desktopQuery.matches) return;
    if (event.target.closest('a[href]')) return;

    event.preventDefault();
    event.stopPropagation();
  }

  openOnHover() {
    if (!this.desktopQuery.matches || !this.mainDetailsToggle) return;
    window.clearTimeout(this.closeTimer);
    this.mainDetailsToggle.classList.remove('is-closing');
    this.openTimer = window.setTimeout(() => {
      this.mainDetailsToggle.classList.remove('is-closing');
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', true);
    }, 25);
  }

  closeOnHover() {
    if (!this.desktopQuery.matches) return;
    window.clearTimeout(this.openTimer);
    this.closeTimer = window.setTimeout(() => {
      if (this.matches(':hover')) return;
      this.close();
    }, 120);
  }

  close() {
    if (!this.mainDetailsToggle) return;

    if (!this.desktopQuery.matches || !this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.classList.remove('is-closing');
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', false);
      return;
    }

    this.mainDetailsToggle.classList.add('is-closing');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', false);

    window.clearTimeout(this.closeAnimationTimer);
    this.closeAnimationTimer = window.setTimeout(() => {
      if (this.matches(':hover')) {
        this.mainDetailsToggle.classList.remove('is-closing');
        this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', true);
        return;
      }

      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.classList.remove('is-closing');
    }, 380);
  }

  onToggle() {
    if (!this.header || !this.mainDetailsToggle) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.mainDetailsToggle.classList.remove('is-closing');
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Desktop nested submenu hover support: second-level items with children open on hover,
// while the text link can still navigate directly. Closing is delayed so the menu fades out.
const libuNestedMenuTimers = new WeakMap();

function libuOpenNestedMenu(details) {
  const timer = libuNestedMenuTimers.get(details);
  if (timer) window.clearTimeout(timer);
  details.classList.remove('is-closing');
  details.setAttribute('open', '');
  details.querySelector('summary')?.setAttribute('aria-expanded', true);
}

function libuCloseNestedMenu(details) {
  const oldTimer = libuNestedMenuTimers.get(details);
  if (oldTimer) window.clearTimeout(oldTimer);

  details.classList.add('is-closing');
  details.querySelector('summary')?.setAttribute('aria-expanded', false);

  const timer = window.setTimeout(() => {
    if (details.matches(':hover')) {
      details.classList.remove('is-closing');
      details.querySelector('summary')?.setAttribute('aria-expanded', true);
      return;
    }
    details.removeAttribute('open');
    details.classList.remove('is-closing');
  }, 340);

  libuNestedMenuTimers.set(details, timer);
}

document.addEventListener('mouseover', (event) => {
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  const details = event.target.closest('.header__submenu details');
  if (!details) return;
  libuOpenNestedMenu(details);
});

document.addEventListener(
  'click',
  (event) => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    const summary = event.target.closest('.header__submenu details > summary');
    if (!summary || event.target.closest('a[href]')) return;

    event.preventDefault();
    event.stopPropagation();
  },
  true
);

document.addEventListener('mouseout', (event) => {
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  const details = event.target.closest('.header__submenu details');
  if (!details || details.contains(event.relatedTarget)) return;
  libuCloseNestedMenu(details);
});
